<app-header></app-header>
<app-home *ngIf='router.url=="/"'></app-home>
<router-outlet></router-outlet>
<app-footer></app-footer>